import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-recommend-form__modal-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "職種を選択", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "p-recommend-form__modal-aside" }
const _hoisted_6 = ["data-tab", "onClick"]
const _hoisted_7 = { class: "p-recommend-form__modal-content" }
const _hoisted_8 = ["id"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "p-recommend-form__modal-list-1" }
const _hoisted_12 = { class: "p-login-form__radio" }
const _hoisted_13 = ["id", "name", "value", "checked", "onChange"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "p-recommend-form__modal-foot" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "指定する", -1)
const _hoisted_18 = [
  _hoisted_17
]

import { DialogOccupData, MstOccupClass1, MstOccupClass2, MstOccupClass3 } from '@/types/mstMyPage';
import { domHelperUtils } from '@/utils/domHelper';
import { computed, onMounted, ref, watch, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';

export default /*#__PURE__*/_defineComponent({
  __name: 'OccupationRadio',
  props: {
    selectedOccupation: null,
    isActive: { type: Boolean },
    name: null,
    nameElement: null
  },
  emits: ["update:selectedOccupation", "update:isActive", "update:setValue"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'update:selectedOccupation',
    value: {
      ocupctg3Id: string;
      ocupctg3Text: string;
    }
  ): void;
  (e: 'update:isActive', value: boolean): void;
  (
    e: 'update:setValue',
    value: {
      ocupctg3Id: string;
      ocupctg3Text: string;
      name?: string;
    }
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedOccupation?: {
    ocupctg3Id: string;
    ocupctg3Text: string;
  };
  isActive: boolean;
  name: string;
  nameElement?: string;
}

const storeBase = MYPAGE_CONSTANTS.STORE_MST;

const modalClass = ref({
  'is-active': false,
});

const dialogData = ref<DialogOccupData>();
const currentTab = ref(0);



watch(
  () => props.isActive,
  (newVal) => {
    modalClass.value['is-active'] = newVal;
    if (newVal && props.selectedOccupation) {
      updateCheckboxesFromIds(props.selectedOccupation);
    }
    
    // Add or remove event listener based on modal state
    if (newVal) {
      document.addEventListener('keydown', handleKeyDown);
      domHelperUtils.disableBodyScroll();
    } else {
      document.removeEventListener('keydown', handleKeyDown);
      domHelperUtils.enableBodyScroll();
    }
});

// Handle keydown events
const handleKeyDown = (event: KeyboardEvent): void => {
  // Close modal when ESC key is pressed
  if (event.key === 'Escape' || event.key === 'Esc') {
    hideDialog();
  }
};



const selectedOccupation = computed(() => {
  if (!dialogData.value)
    return {
      ocupctg3Id: '',
      ocupctg3Text: '',
    };

  const result = {
    ocupctg3Id: '',
    ocupctg3Text: '',
  };

  dialogData.value.selectbox1.forEach((box1, i) => {
    box1.selectbox2.forEach((box2) => {
      box2.selectbox3.forEach((box3) => {
        if (box3.isChecked) {
          // selectbox3がチェックされている場合、そのIDをjobsearchOcupctg3idに追加
          result.ocupctg3Id = box3.value;
          result.ocupctg3Text = box3.text;

          currentTab.value = i;
          box1.isOpened = true;
          box2.isOpened = true;
        }
      });
    });
  });

  return result;
});

// 条件をクリア
function clearAllSelections(isResetTab = true) {
  if (!dialogData.value) return;

  if (isResetTab) currentTab.value = 0;

  dialogData.value.selectbox1.forEach((box1) => {
    if (isResetTab) box1.isOpened = false;
    box1.selectbox2.forEach((box2) => {
      if (isResetTab) box2.isOpened = false;
      box2.selectbox3.forEach((box3) => {
        box3.isChecked = false;
      });
    });
  });
}

// 指定する
function submitSelection(isFromOnMounted = false) {
  emit('update:selectedOccupation', selectedOccupation.value);
  emit('update:isActive', false);
  if (!isFromOnMounted) {
    emit('update:setValue', {
      ocupctg3Id: selectedOccupation.value.ocupctg3Id,
      ocupctg3Text: selectedOccupation.value.ocupctg3Text,
      name: props.nameElement,
    });
  }
}

function updateCheckboxesFromIds(selectedData: { ocupctg3Id: string; ocupctg3Text: string }) {
  if (!dialogData.value) return;

  clearAllSelections();

  dialogData.value.selectbox1.forEach((box1, i) => {
    box1.selectbox2.forEach((box2) => {
      box2.selectbox3.forEach((box3) => {
        if (selectedData.ocupctg3Id == box3.value) {
          box3.isChecked = true;

          currentTab.value = i;
          box1.isOpened = true;
          box2.isOpened = true;
        }
      });
    });
  });

  // re-open checked sections
  const openedItems = document.querySelectorAll(`#occup-radio-dialog-body-${props.name.replace('.', '\\.')} .-is-opened`);
  openedItems.forEach(item => {
    if ((item as HTMLElement).style.display == 'none') {
      (item as HTMLElement).style.display = '';
    }
  });
}

function hideDialog() {
  modalClass.value['is-active'] = false;
  emit('update:isActive', false);
}

const store = useStore();
onMounted(async () => {
  dialogData.value = await store.dispatch(storeBase.DIALOG_OCCUPATION);
  clearAllSelections();

  // 初期選択値があれば設定
  if (props.selectedOccupation && props.selectedOccupation.ocupctg3Id) {
    updateCheckboxesFromIds(props.selectedOccupation);
    submitSelection(true);
  }

  // Add event listener if modal is active on mount
  if (props.isActive) {
    document.addEventListener('keydown', handleKeyDown);
  }
});

// Clean up event listener when component is unmounted
onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});

function handleCheckbox3(checkbox: MstOccupClass3, isChecked: boolean) {
  clearAllSelections(false);
  // チェックボックス第3階層の状態を更新
  checkbox.isChecked = isChecked;
}

function toggleBox1(target: HTMLElement, box1: MstOccupClass1) {
  const radContainer = target.nextElementSibling as HTMLElement;
  if (radContainer) {
    if (box1.isOpened) {
      domHelperUtils.toggle.initOpen(radContainer);
      domHelperUtils.toggle.closeAccordion(radContainer);
    } else {
      domHelperUtils.toggle.openAccordion(radContainer);
    }
  }
  box1.isOpened = !box1.isOpened;
}
function toggleBox2(target: HTMLElement, box2: MstOccupClass2) {
  const radContainer = target.nextElementSibling as HTMLElement;
  if (radContainer) {
    if (box2.isOpened) {
      domHelperUtils.toggle.initOpen(radContainer);
      domHelperUtils.toggle.closeAccordion(radContainer);
    } else {
      domHelperUtils.toggle.openAccordion(radContainer);
    }
  }
  box2.isOpened = !box2.isOpened;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-recommend-form__modal", modalClass.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", {
        class: "p-recommend-form__modal-close",
        onClick: hideDialog
      }, _hoisted_3),
      _createElementVNode("div", {
        class: "p-recommend-form__modal-body",
        id: `occup-radio-dialog-body-${__props.name}`
      }, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.selectbox1, (item, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: _normalizeClass({ __current: i == currentTab.value }),
              "data-tab": `job-tab${i + 1}`,
              onClick: ($event: any) => (currentTab.value = i)
            }, [
              _createElementVNode("span", null, _toDisplayString(item.text), 1)
            ], 10, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.selectbox1, (box1, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["p-recommend-form__modal-tab", { __current: i == currentTab.value }]),
              key: box1.id,
              id: `job-tab${i + 1}`
            }, [
              _createElementVNode("h4", {
                class: _normalizeClass(["p-recommend-form__modal-heading-1", { '-is-opened': box1.isOpened }]),
                onClick: ($event: any) => (toggleBox1($event.target as HTMLElement, box1))
              }, _toDisplayString(box1.text), 11, _hoisted_9),
              _createElementVNode("div", {
                class: _normalizeClass(["p-recommend-form__modal-wrap", { '-is-opened': box1.isOpened }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box1.selectbox2, (box2, j) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: box2.id,
                    class: "p-recommend-form__modal-wrap-group"
                  }, [
                    _createElementVNode("h5", {
                      class: _normalizeClass(["p-recommend-form__modal-heading-2", { '-is-opened': box2.isOpened }]),
                      onClick: ($event: any) => (toggleBox2($event.target as HTMLElement, box2))
                    }, _toDisplayString(box2.text), 11, _hoisted_10),
                    _createElementVNode("div", {
                      class: _normalizeClass(["p-recommend-form__modal-list-1-wrap", { '-is-opened': box2.isOpened }])
                    }, [
                      _createElementVNode("ul", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box2.selectbox3, (box3, k) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: box3.id
                          }, [
                            _createElementVNode("span", _hoisted_12, [
                              _createElementVNode("input", {
                                id: `form-job-list-${__props.name}${i}${j}${k}`,
                                type: "radio",
                                name: `form-job-list-${__props.name}`,
                                value: box3.value,
                                checked: box3.isChecked,
                                onChange: ($event: any) => (handleCheckbox3(box3, ($event.target as HTMLInputElement).checked))
                              }, null, 40, _hoisted_13),
                              _hoisted_14
                            ]),
                            _createElementVNode("label", {
                              class: "p-recommend-form__label",
                              for: `form-job-list-${__props.name}${i}${j}${k}`
                            }, _toDisplayString(box3.text), 9, _hoisted_15)
                          ]))
                        }), 128))
                      ])
                    ], 2)
                  ]))
                }), 128))
              ], 2)
            ], 10, _hoisted_8))
          }), 128))
        ])
      ], 8, _hoisted_4),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          class: "p-recommend-form__modal-set js-modal-set",
          type: "button",
          onClick: _cache[0] || (_cache[0] = () => submitSelection())
        }, _hoisted_18)
      ])
    ]),
    _createElementVNode("div", {
      class: "p-recommend-form__modal-close-area",
      onClick: hideDialog
    })
  ], 2))
}
}

})